export const TOOLTIP_MESSAGES = {
  TRACKING_CODE: 'Click the icon button to copy the Tracking Code snippet to the clipboard',
  TRACKING_URL: 'Click the icon button to copy the Tracking URL link to the clipboard',
  IMPRESSION_URL: 'Click the icon button to copy the Impression URL link to the clipboard',
};

export const COPIED_MESSAGES = 'copied to clipboard!';
